import { zodResolver } from '@hookform/resolvers/zod';
import { Modal, Stack } from '@mantine/core';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import { FileInputControl, Form } from '@/core/components';

interface GovEvaluationAuthorAnnexModalProps {
  onSubmit: (v: DataSchema) => void;
  isSubmitting: boolean;
  onClose: () => void;

  title: string;
  type: string;
}

const schema = z.object({
  signedFile: z.instanceof(File),
  editableFile: z.instanceof(File),
  type: z.string(),
});

type DataSchema = z.infer<typeof schema>;

export function GovEvaluationAuthorAnnexModalForm(props: GovEvaluationAuthorAnnexModalProps) {
  const { onClose, isSubmitting, onSubmit, type, title } = props;
  const defaultValues = {
    type,
  };

  const { t } = useTranslation();
  const { control, handleSubmit } = useForm<DataSchema>({
    defaultValues,
    resolver: zodResolver(schema),
  });

  return (
    <Modal
      opened
      centered
      onClose={onClose}
      title={title}
    >
      <Form
        onSubmit={handleSubmit(onSubmit)}
        onCancel={onClose}
        title=""
        isSubmitting={isSubmitting}
      >
        <Stack gap="xl">
          <FileInputControl
            withAsterisk
            name="editableFile"
            control={control}
            label={t('govEvaluation.editableXlsxAnnex')}
            isSubmitting={isSubmitting}
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          />
          <FileInputControl
            withAsterisk
            name="signedFile"
            control={control}
            label={t('govEvaluation.signedPdfAnnex')}
            isSubmitting={isSubmitting}
            accept="application/pdf"
          />
        </Stack>
      </Form>
    </Modal>
  );
}
